var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3L12 21L22.5 3H18.375L12 13.875L5.625 3H1.5Z",
    fill: "#41B883"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 3L12 13.875L18.375 3H14.625L12.049 7.50945L9.375 3H5.625Z",
    fill: "#35495E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVue);
export default __webpack_public_path__ + "static/media/Vue.6d9ed88584fdf3bda3741f343544dd18.svg";
export { ForwardRef as ReactComponent };